module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/alert-863c3dd811c159ad86d04308c0fc4be9.svg&quot;;"